module.exports = __webpack_public_path__ + "images/jasny.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/jasny.jpg
// module id = 24
// module chunks = 0